import useTranslator from "../../hooks/useTranslator";

const DocsStatus = ({ missingCount, isPending = false }) => {
  const { _t } = useTranslator();

  if (isPending) return "-";

  if (missingCount === 0) {
    return (
      <div className="d-flex align-items-center custom-gap-2">
        <svg
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#487A28"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <circle cx="12" cy="12" r="10"></circle>
          <path d="M8 12l3 3 5-6"></path>
        </svg>
        <span style={{ color: "#487A28", fontWeight: 500 }}>
          {_t("complete")}
        </span>
      </div>
    );
  }

  return (
    <div className="d-flex align-items-center custom-gap-2">
      <svg
        width="18"
        height="18"
        viewBox="0 0 24 24"
        fill="none"
        stroke="#9A6A1E"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>
        <line x1="12" y1="9" x2="12" y2="13"></line>
        <line x1="12" y1="17" x2="12.01" y2="17"></line>
      </svg>
      <span style={{ color: "#9A6A1E", fontWeight: 500 }}>
        {missingCount} {_t("docsMissing")}
      </span>
    </div>
  );
};

export default DocsStatus;
